/*!

=========================================================
* Central System - v1.0.0
=========================================================

* Coded by Aircode

=========================================================

*/
import React from "react";
import './CheckoutDetails.css'

import { ProductContext } from 'views/pages/LandingPage/Context/productContext.js';
import { openGetCoupon, postSubscription } from "../../../../network/ApiAxios";
import secureLocalStorage from "react-secure-storage";

// reactstrap components
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Input,
} from "reactstrap";
import PayPalPayments from "./PayPalPayments";

class CheckoutDetails extends React.Component {

  static contextType = ProductContext;

  constructor(props) {
    super(props);
    this.state = {
      discount: 0.00,
      coupon: '',
      finalPrice: 0.00,
    };

    this.user = JSON.parse(secureLocalStorage.getItem("user"));
    this.handleCouponChange = this.handleCouponChange.bind(this)
    this.applyCoupon = this.applyCoupon.bind(this)
    this.handleGuest = this.handleGuest.bind(this)
  }

  /**
   * Busca no banco de dados do Sistema Central as informações
   * do cupom de acordo com seu código informado pelo usuário.
   * Atualiza os calculos de valoress finais.
   * 
   * @param {*} event 
   */
  applyCoupon(event) {
    const runAsync = async () => {
      const response = await openGetCoupon(this.state.coupon);
      const { data } = response;

      if (data.success) {
        const { selectedProduct, selectedPlan } = this.context;
        let discount = data.coupon.isPercentage ? (data.coupon.value / 100.00 * selectedPlan.price) : data.coupon.value;
        let finalPrice = discount > selectedPlan.price ? 0.00 : selectedPlan.price - discount;

        //atualiza varivaveis de contexto da página
        this.setState({
          discount: discount,
          finalPrice: finalPrice
        })
        //adiciona disconto ao dados do plano
        let planData = {
          ...this.context.selectedPlan,
          ...{ discount: discount?.toFixed(2) }
        }
        this.context.setSelectedPlan(planData)

      } else {
        this.setState({ discount: 0.00 })
      }
    }

    //verifica se tem cupom para recalcular preços
    //e se não tiver, zerar todos os descontos
    //eventualmente aplicados
    if (this.state.coupon) {
      runAsync();
    } else {
      //atualiza varivaveis de contexto da página
      this.setState({ discount: 0.00 })
      //zera o disconto ao dados do plano
      let planData = {
        ...this.context.selectedPlan,
        ...{ discount: 0.00 }
      }
      this.context.setSelectedPlan(planData)
    }
  }

  /**
   * Atualiza o state com o código do cupom de desconto
   * 
   * @param {*} event 
   */
  handleCouponChange(event) {
    this.setState({ coupon: event.target.value })
  }

  /**
   * Trata casos de convidados com disconto integral os quis
   * não é necessário processar pagamento via PayPal
   * 
   * @param {*} event 
   */
  handleGuest(event) {
    const runAsync = async () => {
      const { selectedProduct, selectedPlan } = this.context;

      const subscription = {
        account: this.user.account,
        licensesLimit: selectedPlan.licensesCount,
        app: selectedProduct.id,
        periodicity: selectedPlan.periodicity,
      }

      const response = await postSubscription(subscription);
      const { data } = response;

      if (data.success) {
        //Limpar os caches de dados temporários de configuração
        //de plano
        localStorage.setItem('planSelectionData', null)
        localStorage.setItem('selectedPlan', null)
        localStorage.setItem('selectedProduct', null)

        //redirect para a tela inicial do Sistema Central 
        window.location.replace('/admin')
      } else {
        throw new Error(data.msg)
      }

    }

    runAsync();
  }

  render() {
    const { selectedProduct, selectedPlan } = this.context;

    if (!selectedProduct || !selectedPlan) {
      return (
        <section className="section section-lg checkout-section">
          <Container className="checkout-container py-5">
            <h1 className="mb-3">Checkout</h1>
            <p>Nenhum produto ou plano selecionado. <a href="/">Voltar para a página principal</a></p>
          </Container>
        </section>
      );
    }

    return (
      <>
        <section className="section section-lg checkout-section">
          <Container className="checkout-container py-5 ">
            <h1 className="mb-3">Checkout</h1>
            <Row className="row-grid align-items-start justify-content-between">
              <Col className="order-md-1 checkout-product-img" md="6">

                <div className="product-header d-flex align-items-center mb-3">
                  <img
                    alt="Produto"
                    className="product-icon"
                    src={selectedProduct?.productImg}
                  />
                  <div className="ml-3">
                    <h2 className="mb-0">{selectedProduct?.name}</h2>
                    <h6 className="plan-name">{selectedPlan?.name}</h6>
                  </div>
                </div>

                <Row className="mb-3">
                  <Col className="text-left" md="12">Do you have a coupon?</Col>
                  <Col className="text-left" xs="8">
                    <Input
                      type="text"
                      name="coupon"
                      id="coupon"
                      className="text-left"
                      value={this.state.coupon}
                      onChange={this.handleCouponChange}
                      min="1"
                    />
                  </Col>
                  <Col className="text-left" xs="4">
                    <Button
                      color="secondary"
                      type="button"
                      size="sx"
                      onClick={this.applyCoupon}
                      block
                      className="w-100 shadow-none"
                    >
                      Apply
                      {this.state.discount > 0 ? (<i className="ni ni-check-bold text-green"></i>) : <></>}
                    </Button>
                  </Col>
                </Row>

                <div className="d-flex justify-content-between align-items-center mt-2 checkout-row">
                  <span>{`${selectedProduct?.name}:`}</span>
                  <strong>${selectedPlan.price}</strong>
                </div>

                <div className="d-flex justify-content-between align-items-center mt-2 checkout-row">
                  <span>Number of Licenses:</span>
                  <span>{selectedPlan.licensesCount}</span>
                </div>

                <div className="d-flex justify-content-between align-items-center mt-2 checkout-row">
                  <span>Discount:</span>
                  <span>{`$${this.state.discount.toFixed(2)}`}</span>
                </div>

                <hr className="my-1" />
                
                <div className="d-flex justify-content-between align-items-center mt-2 mb-5 checkout-row">
                  <strong>Estimated total:</strong>
                  <strong>${this.state.discount > 0 ? this.state.finalPrice.toFixed(2) : selectedPlan.price.toFixed(2)}</strong>
                </div>

              </Col>
              <Col className="order-md-2" md="5">
                <div className="checkout-details mt-1">
                  <h2 className="mb-3">Choose how to pay</h2>

                  {function (parent) {
                    if (
                      (parent.state.discount > 0 && parent.state.finalPrice == 0.00) ||
                      (parent.state.discount > 0 && parent.state.finalPrice < process.env.REACT_APP_PAYPAL_SMALLEST_TRANSACTION)
                    ) {
                      return (
                        <Button color="primary" onClick={parent.handleGuest} block >
                          <i className="ni ni-lock-circle-open mr-2"></i> Subscribe as a Guest
                        </Button>
                      )
                    } else {
                      return (
                        <PayPalPayments selectedProduct={selectedProduct} selectedPlan={selectedPlan}></PayPalPayments>
                      )
                    }
                  }(this)
                  }

                </div>
              </Col>


            </Row>








          </Container>
        </section>

      </>
    )
  }
}

export default CheckoutDetails;